import React, { useEffect, useState } from "react";
import Preloader from "../../Components/Preloader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { NavLink } from "react-router-dom";
import Home_Seo from "../../SEO/Home_Seo";
import AOS from "aos";
import Typewriter from "typewriter-effect";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay } from 'swiper/modules';

function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 500); // Simulating a 1-second delay
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 650,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Home_Seo />
          <Header />
          {/* Start Banner Area */}
          <div className="hero-area position-relative overflow-hidden">
            <div className="container-fluid eighteen-padding bg-color-theme ptb-70 radius-30">
              <div className="hero-content">
                <div className="row align-items-center">
                  <div className="col-xl-12 col-lg-12"
                    data-aos="zoom-in-up"
                    data-aos-delay={500}>
                    <div
                      id="bfabanner_section"
                      className="bfabanner_section mb-3 clearfix"
                    >
                      <div className="bfabanner_boxed p-30 bg-bfa-background">
                        <div className="row align-items-center justify-content-lg-between justify-content-md-center justify-content-sm-center">
                          <div className="col-lg-2 col-md-12 text-center">
                            <img src="assets/images/bfa-leaderboard/bfa-logo.png" />
                          </div>
                          <div className="col-lg-8 col-md-12">
                            <div className="section_title_bfa decrease_size">
                              <h2
                                className="title_text mb-1"
                                style={{ color: "aqua" }}
                              >
                                <span style={{ fontWeight: "lighter" }}>
                                  Proud winner of
                                </span>
                                <br />
                                "Startup of the year 2025".
                              </h2>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-12 btn-bfa">
                            <NavLink
                              to="https://britfintechawards.com/award-winners-2025/ifepay-startup-of-the-year-2025"
                              className="bfa-banner-btn"
                              target="_blank"
                            >
                              Learn More
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xl-7 col-lg-12"
                    data-aos="zoom-in-up"
                    data-aos-delay={500}
                  >
                    <div className="title position-relative">
                      <span className="sub-t">
                        Fast, Secure, and Reliable Money Transfer Service
                      </span>
                      <h1 className="text-white">
                        Send Money to{" "}
                        <span style={{ color: "#EBA12A" }}>
                          <Typewriter
                            options={{
                              strings: [
                                "Nigeria",
                                "Ghana",
                                "Kenya",
                                "Senegal",
                                "Cameroon",
                              ],
                              autoStart: true,
                              loop: true,
                            }}
                          />
                        </span>{" "}
                        with Ifepay
                      </h1>
                    </div>
                  </div>
                  <div
                    className="col-xl-5 col-lg-12"
                    data-aos="zoom-in-up"
                    data-aos-delay={500}
                  >
                    <div className="paragraph position-relative">
                      <p className="text-white">
                        Combining cutting-edge technology with a user-friendly
                        platform, Ifepay ensures your international transactions
                        are fast, secure, and affordable. Whether you're
                        supporting loved ones or managing business payments,
                        trust Ifepay to deliver your money with speed and
                        reliability.
                      </p>
                      <NavLink
                        to="/download-ifepay-app"
                        className="default-btn two"

                      >
                        Send Money <i className="ri-arrow-right-up-line" />
                      </NavLink>
                      {/* <NavLink
                        to="https://ifepay.co.uk/app/app-login.html"
                        className="default-btn two"
                        target="_blank"
                      >
                        Send Money <i className="ri-arrow-right-up-line" />
                      </NavLink> */}
                      <i className="flaticon-star-5 star-5 rotate" />
                    </div>
                  </div>
                </div>
                <div className="hero-revenue pt-100">
                  <div className="row g-4">
                    <div
                      className="col-xl-8 col-lg-12 col-md-12"
                      data-aos="zoom-in-up"
                      data-aos-delay={500}
                    >
                      <div className="feature-account bg-color-theme2 radius-30 position-relative">
                        <h3>
                          You Can Send Money With The Following Four Easy Steps
                        </h3>
                        <ul>
                          <li>
                            <h4>1. Create An Account</h4>
                            <span>
                              Download our app and signup within minutes. It's
                              easy and free.
                            </span>
                          </li>
                          <li>
                            <h4>2. Set up a transfer</h4>
                            <span>
                              Add beneficiary and enter the amount to send or
                              receive in foreign currency.
                            </span>
                          </li>
                          <li>
                            <h4>3. Pay securely</h4>
                            <span>
                              Complete your payment via Pay with Bank for secure
                              and efficient fund transfer.
                            </span>
                          </li>
                          <li>
                            <h4>4. That's it!</h4>
                            <span>
                              Track your transfer in the app; payouts to
                              beneficiary are made as promised.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="col-xl-4 col-lg-12 col-md-12"
                      data-aos="zoom-in-up"
                      data-aos-delay={500}
                    >
                      <img src="assets/images/aaaa.webp" alt="image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Banner Area */}

          {/* Start Financial About Area */}
          <div className="why-choose-us-area ptb-100 overflow-hidden">
            <div className="container">
              <div className="row align-items-center">
                <div
                  className="col-lg-6 col-md-12"
                  data-aos="zoom-in-up"
                  data-aos-delay={800}
                >
                  <div className="why-choose-us-content">
                    <div className="section-heading mb-0">
                      <span className="sub-title">About Us</span>
                      <h2>About Ifepay</h2>
                      <p className="mb-4">
                        KP Agency Limited, trading as IFEPAY, is a London-based
                        retail money remittance company established in March
                        2009. We are fully regulated by the Financial Conduct
                        Authority (FCA, FRN: 511981), supervised by HMRC (MLR
                        Registration: XFML00000181717), and registered with
                        Companies House (No. 06833430).
                      </p>
                      <NavLink to="/aboutus" className="default-btn">
                        Learn More <i className="ri-arrow-right-up-line" />
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-12"
                  data-aos="zoom-in-up"
                  data-aos-delay={800}
                >
                  <div className="choose-image position-relative">
                    <img
                      className="radius-30"
                      src="assets/images/about/aboutus.jpg"
                      alt="image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End About Area */}

          {/* Start Financial About Area */}
          <div className="financial-about-area pb-100 overflow-hidden">
            <div className="container">
              <div className="row align-items-center">
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up"
                  data-aos-delay={300}
                >
                  <div className="about-image position-relative">
                    <img
                      className="app-image-6 p-2"
                      src="assets/images/about1.webp"
                      alt="image"
                    />
                    <img
                      className="app-image-8 radius-30"
                      src="assets/images/app/app-image-8.jpg"
                      alt="image"
                    />
                    <img
                      className="feature-shape-1 rotate"
                      src="assets/images/shape/feature-shape-1.png"
                      alt="image"
                    />
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-6"
                  data-aos="zoom-in-up"
                  data-aos-delay={300}
                >
                  <div className="financial-about-content">
                    <div className="section-heading mb-3">
                      <span className="sub-title">Why choose us?</span>
                      <h2>Ifepay</h2>
                      {/* <p>KP Agency Limited trading as Ifepay Money Transfer, is a company registered in England and Wales (registration number 06833430).</p> */}
                    </div>
                    <div className="features-content">
                      <ul>
                        <li className="bg-color-fffaeb radius-20">
                          <img
                            className="svg"
                            src="assets/images/svg/Security.svg"
                            alt="image"
                          />
                          <h3>Top- notch security</h3>
                          <p>
                            Your security is our priority. We implement advanced
                            industry security measures. Your funds and personal
                            data is always securely stored, providing you with
                            peace of mind while transacting.
                          </p>
                        </li>
                        <li className="bg-color-fffaeb radius-20">
                          <img
                            className="svg"
                            src="assets/images/svg/0fee.svg"
                            alt="image"
                          />
                          <h3>Zero Transfer Fees</h3>
                          <p>
                            We believe in cost - effective financial services,
                            and that's why we offer zero transfer fees on
                            international transactions. With Ifepay, you save
                            money while sending funds to your loved ones through
                            our app.
                          </p>
                        </li>
                        <li className="bg-color-fffaeb radius-20">
                          <img
                            className="svg"
                            src="assets/images/svg/24.svg"
                            alt="image"
                          />
                          <h3>24/7 Service</h3>
                          <p>
                            At Ifepay we have a dedicated support team to get
                            you on board and initiate your transfer via mobile
                            App , website and polite customer service team.
                          </p>
                        </li>
                        <li className="bg-color-fffaeb radius-20">
                          <img
                            className="svg"
                            src="assets/images/svg/Support.svg"
                            alt="image"
                          />
                          <h3>Supporting Immigrant and business communities</h3>
                          <p>
                            We understand the unique financial needs of
                            immigrants and expatriates . Ifepay is committed to
                            providing reliable financial services tailored to
                            these communities , ensuring hassle - free
                            international transactions.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Financial About Area */}

          {/* Start Faq Area */}
          <div className="faq-area two pb-100">
            <div className="container">
              <div className="row">
                <div
                  className="col-lg-5 col-md-5"
                  data-aos="zoom-in-up"
                  data-aos-delay={300}
                >
                  <div className="section-heading mb-0">
                    <span className="sub-title">FAQ's</span>
                    <h2>Frequently Asked Questions</h2>
                    <p className="mb-5">
                      With a robust suite of products ranging from digital
                      banking and payment processing to wealth management and
                      blockchain applications.
                    </p>
                    <NavLink to="/general-faq" className="default-btn">
                      Show More <i className="ri-arrow-right-up-line" />
                    </NavLink>
                  </div>
                </div>
                <div
                  className="col-lg-7 col-md-7"
                  data-aos="zoom-in-up"
                  data-aos-delay={300}
                >
                  <div className="faq-content">
                    <div className="accordion" id="accordionShould">
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse20"
                          aria-expanded="false"
                          aria-controls="collapse20"
                        >
                          1. Why do you need my documents while registration?
                        </button>
                        <div
                          id="collapse20"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#accordionShould"
                        >
                          <div className="accordion-body">
                            <p>
                              We are regulated by Financial Conduct Authority in
                              the UK. It is our legal binding to verify your
                              identity as a UK resident.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse21"
                          aria-expanded="false"
                          aria-controls="collapse21"
                        >
                          2. How can I cancel my transfer?
                        </button>
                        <div
                          id="collapse21"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionShould"
                        >
                          <div className="accordion-body">
                            <p>
                              Please call us or email us at earliest possible if
                              you want to cancel your transfer. Transfer paid
                              out to the recipient cannot be cancelled. If you
                              have paid for your transfer and the transfer is
                              not processed yet, then please contact us by phone
                              and we will make necessary arrangements for
                              refunds. We may charge you a small fee as
                              handling/service charge and refund you the balance
                              amount.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse22"
                          aria-expanded="false"
                          aria-controls="collapse22"
                        >
                          3. Will I get notifications about Transfer status?
                        </button>
                        <div
                          id="collapse22"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionShould"
                        >
                          <div className="accordion-body">
                            <p>
                              Yes. We send email notifications to keep you
                              informed. You can even view the transfer status by
                              signing in into your web account.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse23"
                          aria-expanded="false"
                          aria-controls="collapse23"
                        >
                          4. How many recipients I can add?
                        </button>
                        <div
                          id="collapse23"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionShould"
                        >
                          <div className="accordion-body">
                            <p>
                              There is no restriction on the number of
                              recipients you may have on your account.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse24"
                          aria-expanded="false"
                          aria-controls="collapse24"
                        >
                          5. You asked me to upload one more document; how can I
                          do that?
                        </button>
                        <div
                          id="collapse24"
                          className="accordion-collapse collapse"
                          data-bs-parent="#accordionShould"
                        >
                          <div className="accordion-body">
                            <p>
                              Please login in to your account and under My
                              Account you will find document section where you
                              can upload the document.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Faq Area */}

          {/* Start App Area */}
          <div className="app-area two pb-100 overflow-hidden">
            <div className="container">
              <div className="download-area bg-color-edf1ee radius-30">
                <div className="row g-4 align-items-center">
                  <div
                    className="col-lg-6 col-md-12"
                    data-aos="zoom-in-up"
                    data-aos-delay={200}
                  >
                    <div className="app-image">
                      <img
                        className="radius-30"
                        src="assets/images/app/app-image-5.webp"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div
                    className="col-lg-6 col-md-12"
                    data-aos="zoom-in-up"
                    data-aos-delay={200}
                  >
                    <div className="section-heading mb-0 ms-auto">
                      <span className="sub-title two bg-color-9edd05 rounded-pill">
                        Download App
                      </span>
                      <h2>Download And Enjoy The Experience</h2>
                      <p className="mb-5">
                        Send money worldwide in seconds with Ifepay app. Enjoy
                        fast transfers, competitive rates, and secure
                        transactions. Track your transfers easily, and all from
                        a user-friendly app.
                      </p>
                      <div className="app-btn">
                        <NavLink
                          to="https://play.google.com/store/apps/details?id=com.remit.IfePay"
                          target="_blank"
                          className="me-3"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/android.png"
                            alt="image"
                          />
                        </NavLink>
                        <NavLink
                          to="https://apps.apple.com/us/app/ifepay/id6744351163"
                          target="_blank"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/apple.png"
                            alt="image"
                          />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End App Area */}

          {/* Footer Section Here */}
          <Footer />
        </>
      )}
    </>
  );
}

export default Home;
